import dashoboard from "assets/Aside/dashBoard.svg";
import orders from "assets/Aside/orders.svg";
import menu from "assets/Aside/menu.svg";
import store from "assets/Aside/store.svg";
import user from "assets/Aside/user.svg";
import reports from "assets/Aside/reports.svg";
import setting from "assets/Aside/setting.svg";
import websiteIcon from "assets/Aside/websiteIcon.svg";

export const navData = [
    {
        icon: dashoboard,
        route: "/dashboard",
        name: "Dashboard",
        permissionRoute: "dashboard",
    },
    {
        icon: orders,
        name: "Orders",
        permissionRoute: "live-orders",
        fakeRoute: "order", // fake route is just for showing current item is active :)
        subMenu: [
            {
                route: "/live-orders",
                name: "Live Orders",
            },
            {
                route: "/order-history",
                name: "Order History",
            },
        ],
    },
    {
        icon: menu,
        route: "/menu-management",
        name: "Menu Management",
        permissionRoute: "menu-management",
    },
    {
        icon: store,
        name: "Store",
        fakeRoute: "store",
        permissionRoute: "manage-stores",

        subMenu: [
            {
                route: "/store-overview",
                name: "Overview",
            },
            {
                route: "/manage-stores",
                name: "Manage stores",
            },
        ],
    },
    {
        icon: user,
        name: "Customers",
        fakeRoute: "customer",
        permissionRoute: "manage-customer",

        subMenu: [
            {
                route: "/manage-customers",
                name: "Manage Customer",
            },
            {
                route: "/manage-users",
                name: "Manage Users",
            },
            {
                route: "/manage-roles",
                name: "Manage Roles",
            },
            {
                route: "/customer-reviews",
                name: "Customer Reviews",
            },
        ],
    },
    {
        icon: reports,
        route: "/reports",
        name: "Reports",
        permissionRoute: "reports",
    },
    {
        icon: websiteIcon,
        route: "/website-builder",
        name: "Website Builder",
        permissionRoute: "website-builder",
    },
    {
        icon: setting,
        route: "/settings",
        name: "Settings",
        permissionRoute: "settings",
    },
];
